import UAParser from 'ua-parser-js';

export const useragent = new UAParser(navigator.userAgent);
